import React from "react";
import Header from "./Header/header";

import "./App.scss";
import "./scss/queries.scss";

function App(props) {
	return (
    <div className="App">
      <Header/>
      <div className="router-view">{props.children}</div>
    </div>
  );
}

export default App;
